import { Box } from '@material-ui/core';
import { FetchWsCatalogueProductTypes } from '@src/reducers/wsCatalogue';
import { useIntl } from 'react-intl';

import NotInterestedOutlinedIcon from '@material-ui/icons/NotInterestedOutlined';

export const ErrorView: React.FC<{ type: FetchWsCatalogueProductTypes }> = ({
  type,
}) => {
  const { formatMessage } = useIntl();
  const ErrorProduct = formatMessage({
    id: 'Ws.Catalogue.product.detail.error.message',
  });
  const ErrorOrder = formatMessage({
    id: 'Ws.Catalogue.shoppingCart.detail.error.message',
  });

  return (
    <Box padding={2}>
      <Box
        display="flex"
        alignItems="center"
        flexDirection="column"
        textAlign="center"
        height="100%"
        paddingTop={5}
      >
        <NotInterestedOutlinedIcon fontSize="large" />
        <Box color="#323444" fontSize={14} paddingTop={2}>
          {type === FetchWsCatalogueProductTypes.PRODUCT && ErrorProduct}
          {type === FetchWsCatalogueProductTypes.CART && ErrorOrder}
        </Box>
      </Box>
    </Box>
  );
};

export default ErrorView;
